module.exports = __webpack_public_path__ + "img/Share.9d28b663.jpg";